export const DOCUMENT_STATUS = {
  PENDING: "pending",
  CAPTURED: "captured",
  UPLOADED: "uploaded",
};

export const VERIFIED_STATUSES = [DOCUMENT_STATUS.CAPTURED, DOCUMENT_STATUS.UPLOADED];

const getInitialKycDocuments = () => ({
  selfie: { status: DOCUMENT_STATUS.PENDING, image: null },
  pan: { status: DOCUMENT_STATUS.PENDING, image: null },
  address: { status: DOCUMENT_STATUS.PENDING, image: null },
});

export const createKycDocumentsSlice = (set) => ({
  kycDocuments: getInitialKycDocuments(),
  reuploadDocuments: getInitialKycDocuments(),
  digilockerUniqueId: null,
  digilockerTransactionId: null,
  okycTxnId: null,
  ckycDownloadId: null,

  updateKycDocumentStatus: (type, status, image) =>
    set((state) => ({
      kycDocuments: {
        ...state.kycDocuments,
        [type]: {
          status,
          image: image ?? null,
        },
      },
    })),

  updateReuploadDocumentStatus: (type, status, image) =>
    set((state) => ({
      reuploadDocuments: {
        ...state.reuploadDocuments,
        [type]: {
          status,
          image: image ?? null,
        },
      },
    })),

  setDigilockerUniqueId: (id) => set({ digilockerUniqueId: id }),
  setDigilockerTransactionId: (id) => set({ digilockerTransactionId: id }),
  setOkycTxnId: (id) => set({ okycTxnId: id }),
  setCkycDownloadId: (id) => set({ ckycDownloadId: id }),

  clearKycDocuments: () =>
    set({
      kycDocuments: getInitialKycDocuments(),
      digilockerUniqueId: null,
      digilockerTransactionId: null,
      okycTxnId: null,
      ckycDownloadId: null,
    }),

  clearReuploadDocuments: () =>
    set({
      reuploadDocuments: getInitialKycDocuments(),
    }),
});
